import React from "react"
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { FormSectionElements, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { dateComparisonList, feedbackStatusOptions, FR_SUFFIX, odsCallOutBoxs } from "../../entities/Constants";
import { InputTextarea } from "primereact/inputtextarea";
import { Editor } from "primereact/editor";
import { Checkbox } from "primereact/checkbox";
import { getRootComponent } from "../../utilities/ElementUtils";
import Utils from "../../utilities/Utils";
import { DialogBase, Props, State } from "./DialogBase";


export class DialogForFeedbackComponent extends DialogBase<Props,State> {

    dateTypeFieldList = [];
    expectedValueOptions = []
    constructor(props: Props) {
        super(props);

        let subSection = this.props.ele.parent as FormSubSections;
        this.dateTypeFieldList = subSection.ListOfFormSectionElements?.filter(p => p.Datatype === 'Date' && p.Sequence < this.props.ele.Sequence);
        if (this.props.ele.Datatype === "RadioButton" && this.props.ele.ListOfLOVValues?.length) {
            this.expectedValueOptions = [{ label: 'Select a expected value', labelFRA: 'Sélectionnez une valeur attendue', val: '' }]
                .concat(
                    this.props.ele.ListOfLOVValues
                        .map(item => ({
                            label: item.description, labelFRA: item.FRADescription, val: item.code
                        }))
                );
        }
    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={this.props.isEng ? "Field Properties for " + this.props.ele.ENUTitle : "Field Properties for " + this.props.ele.FRATitle}
                    footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }}
                    onHide={() => this.props.callback(false)}
                >
                    {this.otherPreviousDateFields()}
                </Dialog>
            </>
        );
        return html;
    }

    otherPreviousDateFields = () => {
        let htmlString = [];
        let programContainer = getRootComponent(this.props.ele);

        htmlString.push(
            <div>
                {this.scriptHtml()}
                {this.updateBindingFieldHtml()}

                {this.listValuesApiHtml()}

                {this.questionHintHtml()}

                {this.emptyErrorMessageHtml()}

                {this.errorMessageHtml()}

                {this.props.ele.Datatype === "RadioButton" && this.props.ele.ListOfLOVValues?.length && 
                   this.expectedValueHtml()
                }

                {this.tooTipHtml()}

                {/* <div style={{ display: this.props.ele.Optional == 'N' ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Customize Error Message</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={this.props.ele.ErrorMessage}
                        onChange={(e) => {
                            if (this.props.isEng)
                                this.props.ele.ErrorMessage = e.target.value;
                            this.props.callback();
                        }}></InputText></div>
                </div> */}

                {this.hintExpansionTitleHtml()}

                {this.calloutBoxHtml()}

                {this.maskSummaryHtml()}

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Feedback URL</div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"feedback-url" + this.props.ele.Sequence} className="ontario-input"
                            value={this.props.isEng ? this.props.ele.FeedbackURL: this.props.ele.FeedbackURLFRA}
                            onChange={(e) => {
                                if (this.props.isEng) {
                                    if(Utils.willDefaultFR(this.props.ele.FeedbackURL,this.props.ele.FeedbackURLFRA)){
                                        this.props.ele.FeedbackURLFRA= Utils.isNullOrEmpty(e.target.value)? '':e.target.value+ FR_SUFFIX;
                                    }
                                    this.props.ele.FeedbackURL = e.target.value;
                                } else {
                                    this.props.ele.FeedbackURLFRA = e.target.value;
                                }
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Feedback URL-CXP specific</div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"feedback-url-cxp" + this.props.ele.Sequence} className="ontario-input"
                            value={this.props.isEng ? this.props.ele.FeedbackURL_CXP: this.props.ele.FeedbackURLFRA_CXP}
                            onChange={(e) => {
                                if (this.props.isEng) {
                                    if(Utils.willDefaultFR(this.props.ele.FeedbackURL_CXP,this.props.ele.FeedbackURLFRA_CXP)){
                                        this.props.ele.FeedbackURLFRA_CXP= Utils.isNullOrEmpty(e.target.value)? '':e.target.value+ FR_SUFFIX;
                                    }
                                    this.props.ele.FeedbackURL_CXP = e.target.value;
                                } else {
                                    this.props.ele.FeedbackURLFRA_CXP = e.target.value;
                                }
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Feedback status</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown key={"feedback-status" + this.props.ele.Sequence} 
                            showClear 
                            options={feedbackStatusOptions} 
                            optionLabel='label' 
                            optionValue='val' 
                            value={this.props.ele.feedback?.status} 
                            onChange={(e) => {
                                this.props.ele.feedback = {...this.props.ele.feedback ?? {}, status: e.value, };
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>code: </div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"feedback-code" + this.props.ele.Sequence} className="ontario-input"
                            value={this.props.ele.feedback?.code}
                            onChange={(e) => {
                                this.props.ele.feedback = {...this.props.ele.feedback ?? {}, code: e.target.value};
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"feedbackLinkIsHyperlink" + this.props.ele.Sequence}>Link as hyperlink:</label>
                    </div>
                    <div style={{ width: '60%' }}>
                    {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.feedbackLinkIsHyperlink} 
                            id={"feedbackLinkIsHyperlink_" + this.props.ele.Sequence}
                            onChange={(e) => { this.props.ele.feedbackLinkIsHyperlink = e.checked; this.props.callback() }} 
                            checked={this.props.ele.feedbackLinkIsHyperlink}
                        />
                    </div>
                </div>

                  {this.props.ele.Datatype == 'TechError' && 
                                <div style={{ display: "flex", marginTop: '10px' }}>
                                    <div style={{ width: '25%' }}>Back URL</div>
                                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={this.props.isEng ? this.props.ele.BackUrl : this.props.ele.BackUrlFRA}
                                        onChange={(e) => {
                                            if (this.props.isEng)
                                                this.props.ele.BackUrl = e.target.value;
                                            else {
                                                this.props.ele.BackUrlFRA = e.target.value;
                                            }
                                            this.props.callback();
                                        }}></InputText></div>
                                </div>
                                }
            </div> 
        )

        return htmlString;
    }

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
